import React, { useState, useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { UnTracked } from './NotTrackedList';
import { commonGetService, handleFilterApi } from '../../utils/properties';
import { showToast } from '../../features/Toaster/toastslice';
import { Image } from 'react-bootstrap';
import LiveEmployeePopup from './LiveEmployeePopup';
import Skeleton from 'react-loading-skeleton';
import "../../styles/Dashboard/activeEmployeesList.scss";
import { useNavigate } from 'react-router-dom';

const ActiveEmployeeList = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [liveEmployeeData, setLiveEmployeeData] = useState<UnTracked[]>([]);
    const [modalShow, setModalShow] = useState<boolean>(false);
    const [count, setCount] = useState<number>((window.innerWidth >= 1609 || (window.innerWidth >= 1085 && window.innerWidth < 1200)) ? 12 :
        (window.innerWidth >= 768 && window.innerWidth < 992) ? 6 : 10);


    const filterData = useAppSelector((state) => state.filterData);
    const dispatch = useAppDispatch();
    const { startDate, endDate, empDeviceId, filterType, organization, department } = filterData; // Destructuring the filterData state value
    const targetRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.5,
        };

        const observerCallback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    getLiveEmployeeData();

                    observer.disconnect();
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, options);

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [startDate, endDate, empDeviceId, filterType, organization, department]);

    //Identify the Desktop size
    useEffect(() => {
        const handleResize = () => {
            setCount((window.innerWidth >= 1609 || (window.innerWidth >= 1085 && window.innerWidth < 1200)) ? 12 :
                (window.innerWidth >= 768 && window.innerWidth < 992) ? 6 : 10);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getLiveEmployeeData = () => {
        setIsLoading(true);
        commonGetService(`/api/1.0/dashboard/users/active?${handleFilterApi(startDate, endDate, filterType, organization, empDeviceId, department, false)}`).
            then(res => {
                setIsLoading(false);
                if (res.status === 200) {
                    setLiveEmployeeData(res?.data);
                }
                else {
                    dispatch(
                        showToast({
                            message: "Something went wrong in API.",
                            status: "retry",
                            visible: true,
                        })
                    );
                    setLiveEmployeeData([]);
                }
            })
    }
    const handleModalClose = () => {
        setModalShow(false)
    }

    return (
        <>
            <div className='active-emp-cont d-flex flex-column' ref={targetRef}>
                <div className="d-flex justify-content-between common-card-title title-ctr">
                    <h5>Active employees</h5>
                    {liveEmployeeData?.length > count &&
                        <div className="emp-mod"
                            onClick={() => setModalShow(true)}
                        >+{liveEmployeeData?.length - count} employees</div>
                    }
                </div>
                <div className='user-cont d-flex'>
                    {isLoading ?
                        Array.from({ length: count })?.map((res, i) => (
                            <div className='user-card d-flex align-items-center'>
                                <div className='img-ctr'>
                                    <Skeleton count={1} circle={true} className="skel-chart" />
                                </div>
                                <div className='des-ctr d-flex flex-column w-100'>
                                    <p><Skeleton className="w-100" count={1} /></p>
                                    <p><Skeleton className="w-100" count={1} /></p>
                                </div>
                            </div>
                        )) :
                        liveEmployeeData?.length ? liveEmployeeData?.filter((_, ind) => ind < count)?.map((res, i) => (
                            <div className='user-card d-flex align-items-center emp-active' key={i}>
                                <div className='img-ctr'>
                                    {res?.image ?
                                        <Image src={res?.image} alt='Active employee' /> :
                                        <div className="img-avatar d-flex justify-content-center align-items-center">
                                            <p>{res?.employee_name?.charAt(0)}</p>
                                        </div>
                                    }
                                </div>
                                <div className='des-ctr d-flex flex-column'>
                                    {/* <p>{res?.employee_name}</p> */}
                                    <p
  style={{ cursor: 'pointer' }}
   onClick={() => navigate('/employeeOverview', { state: { empCode: res?.employee_code || res?.device_id } })}
>
  {res?.employee_name}
</p>
                                    <p>{res?.designation}</p>
                                </div>
                            </div>
                        )) :
                            <div className="d-flex flex-row  w-100 no-data-row">
                                <div className="no-data-image-wrapper no-user-image">
                                    <Image src="/images/dashboard/user_icon.png" alt="No Data Found" />
                                </div>
                                <p>No users to show</p>
                            </div>
                    }
                </div>
            </div>
            <LiveEmployeePopup modalShow={modalShow} handleModalClose={handleModalClose} liveEmployeeData={liveEmployeeData} />
        </>
    );
};

export default ActiveEmployeeList;